export const SeatSelectionDetailsMode = {
  Inline: "inline",
  Drawer: "drawer"
} as const;

export type SeatSelectionDetailsMode =
  (typeof SeatSelectionDetailsMode)[keyof typeof SeatSelectionDetailsMode];
